<template>
    <div class="ma-2">
        <v-row no-gutters align="center" class="mb-2">
            <v-btn small link class="ma-2" @click="exportXLS()">{{ $t("page.events.registration.xls") }}</v-btn>
            <v-btn small link class="ma-2" @click="exportCVS()">{{ $t("page.events.registration.cvs") }}</v-btn>
            <v-btn small link class="ma-2" @click="exportPDF()">{{ $t("page.events.registration.pdf") }}</v-btn>
        </v-row>
        <v-row no-gutters align="center">
            <v-col cols="12" sm="12">
                <v-card>
                    <VueTabulator
                        ref="tabulator"
                        v-model="participants"
                        :options="tabulatorOptions"
                    />
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
/*
function paramBuilder(column) {
  var list = {
    "": "",
  };
  var data = this.getData().map((a) => a[column]);

  data.forEach(function (item) {
    if (typeof item !== "undefined") {
      list[item] = item;
    }
  });
  return list;
}

function partial(func) {
  var args = Array.prototype.slice.call(arguments, 1);
  return function () {
    var allArguments = args.concat(Array.prototype.slice.call(arguments));
    return func.apply(this, allArguments);
  };
}
*/

export default {
  props: ["participants"],
  computed: {
    tabulatorOptions: function () {
        const formatCheck = function (cell) {
            let value = cell.getValue();
            return value === "yes"
            ? "<i class='far fa-check'></i>"
            : "<i class='far fa-times'></i>";
        };
        const formatTransponder = function (cell) {
            let value = cell.getValue();
            return value === "yes"
            ? "<i class='fas fa-check-circle color-check'></i>"
            : "<i class='fas fa-times-circle color-failed'></i>";
        };
        return {
            placeholder: this.$t("page.events.tabulator.noRegistrantsYet"),
            downloadRowRange: "all",
            printAsHtml: true,
            layout: "fitDataStretch",
            responsiveLayout: false,
            tooltips: true,
            addRowPos: "top",
            history: true,
            movableColumns: false,
            resizableColumns: false,
            initialSort: [
                { column: "number", dir: "asc", },
                { column: "regBy", dir: "asc" }
            ],
            columns: [
                {
                    title: this.$t("page.events.tabulator.full-name"),
                    field: "fullName",
                    //sorter: "string",
                    width: 200,
                    headerFilter: "input",
                    headerFilterPlaceholder: " ",
                },
                {
                    title: this.$t("page.events.tabulator.number"),
                    field: "number",
                    sorter: "alphanum",
                    sorterParams: {
                    alignEmptyValues: "bottom",
                    },
                    width: 100,
                    headerFilter: "input",
                    headerFilterPlaceholder: " ",
                },
                {
                    title: this.$t("page.events.tabulator.class"),
                    field: "name",
                    //sorter: "string",
                    width: 100,
                    headerFilter: "input",
                    headerFilterPlaceholder: " ",
                },
                {
                    title: this.$t("page.events.tabulator.shown-up"),
                    field: "tagWritten",
                    //sorter: "string",
                    width: 150,
                    cssClass: "text-center",
                    formatter: formatCheck,
                },
                {
                    title: this.$t("page.events.tabulator.reg-by"),
                    field: "regBy",
                    sorter: "string",
                    sorterParams: {
                        alignEmptyValues: "bottom",
                    },
                    width: 150,
                    formatter: "textarea",
                    headerFilter: "input",
                    headerFilterPlaceholder: " ",
                },
                {
                    title: this.$t("page.events.tabulator.reserved"),
                    field: "isReserved",
                    //sorter: "string",
                    width: 120,
                    cssClass: "text-center",
                    formatter: formatCheck,
                },
                {
                    title: this.$t("page.events.tabulator.status"),
                    field: "status",
                    width: 150,
                    headerFilter: "select",
                    headerFilterParams: {values: true},
                    headerFilterPlaceholder: " ",
                    editorParams: {},
                    formatter: function(cell) {
                        let value = cell.getValue();
                        return this.$t(`common.${value}`);
                    }.bind(this),
                },
                {
                    title: this.$t("page.events.tabulator.wait"),
                    field: "waitingList",
                    //sorter: "string",
                    width: 100,
                    cssClass: "text-center",
                    formatter: formatCheck,
                },
                {
                    title: this.$t("page.events.tabulator.transponder"),
                    field: "tagId",
                    //sorter: "string",
                    width: 100,
                    cssClass: "text-center",
                    formatter: formatTransponder,
                },
            ],
            dataLoaded: function () {
                this.getColumn("status").reloadHeaderFilter();

                if (this.getRows().length > 10) {
                    this.setHeight(450);
                }
            },
        };
    },  
  },
  methods: {
      exportXLS() {
          const tabulatorInstance = this.$refs.tabulator.getInstance();
          tabulatorInstance.downloadToTab("xlsx", "data.xlsx");
      },
      exportCVS() {
          const tabulatorInstance = this.$refs.tabulator.getInstance();
          tabulatorInstance.downloadToTab("csv", "data.csv");
      },
      exportPDF() {
          const tabulatorInstance = this.$refs.tabulator.getInstance();
          tabulatorInstance.downloadToTab("pdf", "pdf.csv");
      }
  },
};
</script>

<style>
.tabulator-placeholder {
  width: 0px;
  overflow-y: hidden;
}
.color-check {
  color: var(--v-success-base);
}
.color-failed {
  color: var(--v-error-base);
}
</style>
